import GoogleLogin from "react-google-login";
import axios from "axios";
import { Flex, Heading, useToast } from "@chakra-ui/react";

function LandingPage() {
  const toast = useToast();
  const signinSuccess = async (res) => {
    axios({
      method: "POST",
      url: "https://bulk-messaging-server.herokuapp.com/users/login",
      data: { tokenId: res.tokenId, profile: res.profileObj },
    }).then((response) => {
      localStorage.setItem("profile", JSON.stringify(response.data.user));
      window.location.href = "/contacts";
    });
  };
  const signinFailure = (res) => {
    if ((res.error = "popup_closed_by_user")) {
      toast({
        position: "bottom",
        title: "Login popup closed.",
        description: "You must login to continue.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } else {
      toast({
        position: "bottom",
        title: "Server error",
        description: "Some error while authenticating.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  return (
    <>
      <Flex
        w="100vw"
        h="100vh"
        alignItems="center"
        direction="column"
        justifyContent="center"
      >
        <Heading mb={7}>Sign In to get started.</Heading>
        <GoogleLogin
          isSignedIn={true}
          theme="dark"
          clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
          onSuccess={signinSuccess}
          onFailure={signinFailure}
          cookiePolicy={"single_host_origin"}
        />
      </Flex>
    </>
  );
}

export default LandingPage;
